
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserRepoInterface } from '@/services/Users/Interfaces';
import { getOwnerLabel, setOwnerLabel } from '@/utils/ownerLabelCache';

@Component({
  inject: ['userRepository'],
})
export default class OwnerLabel extends Vue {
  @Prop({ type: String, default: '' })
  public userId!: string;

  private userRepository!: UserRepoInterface;

  public label = '';

  public loading = false;

  public get truncatedId(): string {
    const id = this.userId || '';
    if (id.length <= 16) {
      return id;
    }

    return `${id.slice(0, 8)}…${id.slice(-5)}`;
  }

  public created(): void {
    this.hydrateFromCache();
  }

  @Watch('userId')
  public onUserIdChange(): void {
    this.label = '';
    this.loading = false;
    this.hydrateFromCache();
  }

  public hydrateFromCache(): void {
    if (!this.userId) {
      this.label = '';
      return;
    }

    const cached = getOwnerLabel(this.userId);
    this.label = cached || '';
  }

  public async resolve(): Promise<void> {
    if (!this.userId || this.loading || this.label) {
      return;
    }

    const cached = getOwnerLabel(this.userId);
    if (cached) {
      this.label = cached;
      return;
    }

    await this.fetchAndApply();
  }

  public async refresh(): Promise<void> {
    if (!this.userId || this.loading) {
      return;
    }

    await this.fetchAndApply();
  }

  private async fetchAndApply(): Promise<void> {
    this.loading = true;
    try {
      const users = await this.userRepository.getUsersByIds([this.userId]);
      const user = users && users.length ? users[0] : null;
      const email = user && user.email ? user.email : '';

      if (email) {
        setOwnerLabel(this.userId, email);
        this.label = email;
      } else if (!this.label) {
        this.label = this.userId;
      }
    } catch (err) {
      // Keep current label / clickable id.
    } finally {
      this.loading = false;
    }
  }
}
